import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OnboardingService } from '../onboarding.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-verification-url',
    templateUrl: './verification-url.component.html',
    styleUrls: ['./verification-url.component.scss']
})
export class VerificationURLComponent implements OnInit {
    emailVerified:any=false;
    constructor(private onboardingService: OnboardingService,
        private router: Router,
        private activatedRoute: ActivatedRoute) { }

    ngOnInit(): void {
        const id = this.activatedRoute.snapshot.paramMap.get('id');
        console.log(id)
        this.onboardingService.verifyTokenSetupPassword(id).subscribe((res)=>{
            console.log(res)
            this.router.navigate(['/setup-password'], { state: { token: res.token, email: res.email } })
        }, err=>{
            console.log(err)
            this.emailVerified=true;
            setTimeout(()=>{
                this.router.navigate(['/login'])
            }, 1000)

        })
    }



}
